// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Ake3X","footnote":"styles_footnote__3MCOX","grayText":"styles_grayText__dFc0S"};